import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const mailApi = createApi({
  reducerPath: 'mailApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    sendContactMail: builder.mutation({
      query(req) {
        return {
          url: urls.contactMail,
          method: 'POST',
          data: req,
        };
      },
    }),
    sendCongratulationsMail: builder.mutation({
      query(req) {
        return {
          url: urls.congratulationsMail,
          method: 'POST',
          data: req,
        };
      },
    }),
    sendQuestionToApplicationMail: builder.mutation({
      query(req) {
        return {
          url: urls.questionToApplicationMail,
          method: 'POST',
          data: req,
        };
      },
    }),
    sendFeedbackMail: builder.mutation({
      query(req) {
        return {
          url: urls.feedbackMail,
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const {
  useSendContactMailMutation,
  useSendCongratulationsMailMutation,
  useSendQuestionToApplicationMailMutation,
  useSendFeedbackMailMutation,
} = mailApi;
